import Vue from "vue";
import edApi from "@/public/utils/edApi";
// import Cookies from "js-cookie"
const $edApi = edApi();
const state = {
    files: [],
    members: [],
    curTeamId: "",
    teams: [
        // {
        //     id: "",
        //     team_name: "",
        //     files: [],
        //     members: [],
        //     shareLink: ""
        // }
    ],
    space: {
        total: 0,
        used: 0,
    },
    menus: {
        fileMenu: {
            show: false,
            position: {
                top: 0,
                left: 0,
            },
            fileSelected: null,
        },
    },
    fileSelected: null,
    showTeamInviteModal: false,
};
const getters = {
    curTeam(state) {
        if (!state.curTeamId) return null;
        let i = state.teams.findIndex((item) => {
            return item.id == state.curTeamId;
        });
        if (i !== -1) return state.teams[i];
        else return null;
    },
};
const mutations = {
    setTeamState(state, data) {
        state[data.type] = data.data;
    },
    toCurTeamId(state, payload) {
        state.curTeamId = payload;
    },
    toTeamList(state, payload) {
        Vue.set(state, "teams", payload || []);
    },
    toTeamFiles(state, payload) {
        let teamId = payload.teamId,
            files = payload.files;
        if (files) {
            if (this._vm.isPrivate) {
                files = files.filter((item) => {
                    item.name = item.info.name;
                    return true;
                });
            } else {
                files = files.filter((item) => {
                    if (item.key.match(/.+eddx$/)) {
                        let list = item.key.split("/");
                        let name = list[list.length - 1];
                        name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                        item.name = name;
                        return true;
                    }
                    return false;
                });
            }
        }
        let index = state.teams.findIndex((item) => {
            return item.id == teamId;
        });
        if (index !== -1) {
            Vue.set(state.teams[index], "files", files);
        }
    },
    toTeamMembers(state, payload) {
        let teamId = payload.teamId,
            members = payload.members;
        members.sort((a, b) => b.role - a.role);
        let index = state.teams.findIndex((item) => {
            return item.id == teamId;
        });
        if (index !== -1) {
            Vue.set(state.teams[index], "members", members);
        }
    },
    toTeamShareLink(state, payload) {
        let teamId = payload.teamId,
            shareLink = payload.shareLink;
        let index = state.teams.findIndex((item) => {
            return item.id == teamId;
        });
        if (index !== -1) {
            Vue.set(state.teams[index], "shareLink", shareLink);
        }
    },
    toTeamFileMenu(state, payload) {
        state.menus.fileMenu.show = payload.show;
        state.menus.fileMenu.position.top = payload.position.top;
        state.menus.fileMenu.position.left = payload.position.left;
        state.menus.fileMenu.fileSelected = payload.file;
    },
    toFileSelected(state, payload) {
        state.fileSelected = payload;
    },
    deleteTeam(state, payload) {
        let teamId = payload;
        let i = state.teams.findIndex((item) => {
            return item.id === teamId;
        });
        state.teams.splice(i, 1);
    },
};
const actions = {
    // 获取团队列表
    getTeamList({ commit, rootGetters }) {
        let params = rootGetters.apiParam;
        return new Promise((resolve, reject) => {
            $edApi
                .getTeamList(params)
                .then((res) => {
                    commit("toTeamList", res.data);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //获取团队云空间
    getTeamSpace({ state, rootGetters }) {
        $edApi.getTeamSpace(rootGetters.apiParam).then((res) => {
            let total = res ? res.cpt_storage : 0;
            let used = res ? res.cptused_storage : 0;
            console.log(total, used);
            state.space.total = (total / 1024 / 1024).toFixed(2) + "M";
            state.space.used = (used / 1024 / 1024).toFixed(2) + "M";
        });
    },
    // 创建新的团队
    createNewTeam({ state, rootGetters, dispatch }, teamName) {
        let teams = state.teams;
        let index = 1;
        let temp = teamName;
        while (
            teams.find((team) => {
                return team.name == temp;
            })
        ) {
            temp = `${teamName}(${index})`;
            index++;
        }
        teamName = temp;
        let params = Object.assign(
            {
                teamName,
            },
            rootGetters.apiParam
        );
        return new Promise((resolve, reject) => {
            $edApi
                .createNewTeam(params)
                .then((res) => {
                    dispatch("getTeamList");
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    updateTeamInfo({ rootGetters }, { teamId, teamName }) {
        let teams = state.teams;
        let index = 1;
        let temp = teamName;
        while (
            teams.find((team) => {
                return team.name == temp;
            })
        ) {
            temp = `${teamName}(${index})`;
            index++;
        }
        teamName = temp;
        let params = Object.assign(
            {
                teamId,
                teamName,
            },
            rootGetters.apiParam
        );
        return new Promise((resolve, reject) => {
            $edApi
                .updateTeamInfo(params)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // 获取团队文件
    getTeamFiles({ commit, rootGetters }, teamId) {
        let params = Object.assign(
            {
                teamId,
            },
            rootGetters.apiParam
        );
        return new Promise((resolve, reject) => {
            $edApi
                .getTeamFiles(params)
                .then((res) => {
                    if (res.data && res.data.files) {
                        commit("toTeamFiles", { teamId, files: res.data.files });
                    } else {
                        commit("toTeamFiles", { teamId, files: [] });
                    }
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // 新增团队文件
    importTeamFilesFromCloud({ rootGetters }, { teamId, id, file_key }) {
        let params = Object.assign(
            {
                teamId,
                obj_id: id,
                file_key,
            },
            rootGetters.apiParam
        );
        return new Promise((resolve, reject) => {
            $edApi
                .importTeamFilesFromCloud(params)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // 删除团队文件
    deleteTeamFile({ rootGetters }, { teamId, fileId, file_key }) {
        let params = Object.assign(
            {
                teamId,
                fileId,
                file_key,
            },
            rootGetters.apiParam
        );
        return new Promise((resolve) => {
            $edApi.deleteTeamFile(params).then((res) => {
                resolve(res);
            });
        });
    },
    // 获取团队成员
    getTeamMembers({ commit, rootGetters }, teamId) {
        let params = Object.assign(
            {
                teamId,
            },
            rootGetters.apiParam
        );
        return new Promise((resolve, reject) => {
            $edApi
                .getTeamMembers(params)
                .then((res) => {
                    resolve(res);
                    commit("toTeamMembers", { teamId, members: res.data.members });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    updateTeamMember({ rootGetters }, { teamId, userId, role, isDelete }) {
        let params = Object.assign(
            {
                teamId,
                userId,
                role,
                isDelete,
            },
            rootGetters.apiParam
        );
        return new Promise((resolve) => {
            $edApi.updateTeamMember(params).then((res) => {
                resolve(res);
            });
        });
    },
    createTeamShareLink({ commit, rootGetters }, { teamId, role }) {
        let params = Object.assign(
            {
                teamId,
                role,
            },
            rootGetters.apiParam
        );
        return new Promise((resolve) => {
            $edApi.createTeamShareLink(params).then((res) => {
                resolve(res);
                commit("toTeamShareLink", { teamId, shareLink: res.data.ticket });
            });
        });
    },
    joinTeamByCode({ rootGetters }, code) {
        let params = Object.assign(
            {
                code,
            },
            rootGetters.apiParam
        );
        return new Promise((resolve, reject) => {
            $edApi
                .joinTeamByCode(params)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    exitTheTeam({ rootGetters }, teamId) {
        let params = Object.assign(
            {
                teamId,
            },
            rootGetters.apiParam
        );
        return new Promise((resolve) => {
            $edApi.exitTheTeam(params).then((res) => {
                resolve(res);
            });
        });
    },
    deleteTeam({ commit, rootGetters }, teamId) {
        let params = Object.assign(
            {
                teamId,
            },
            rootGetters.apiParam
        );
        return new Promise((resolve) => {
            $edApi.deleteTeam(params).then((res) => {
                resolve(res);
                // dispatch("getTeamList");
                commit("deleteTeam", teamId);
            });
        });
    },
    createNewTeamFile({ rootGetters, dispatch }, { teamId, layout }) {
        // if (layout)
        //     Cookies.set("layout", layout);
        let winref = window.open("");
        dispatch("getTeamFiles", teamId).then(() => {
            console.log(rootGetters.curTeam.files);
            let files = rootGetters.curTeam.files;

            let filename = "newTeamFile";
            //如果当前目录已有同名文件，则在文件名后加上数字
            let count: any = "";
            let temp = ".emmx";
            while (
                files.findIndex((item) => {
                    if (count === "") {
                        temp = ".emmx";
                    } else {
                        temp = "(" + count + ")" + ".emmx";
                    }
                    return item.file_name == filename + temp;
                }) != -1
            ) {
                if (count === "") {
                    count = 1;
                } else {
                    count += 1;
                }
            }
            filename = filename + temp;
            console.log(filename);

            winref.name = btoa(encodeURIComponent(filename));
            // 暂时注释 winref.location.href = location.origin + app.mapUrl + "?team=" + teamId + "&obj=" + filename + "#create";
        });
    },
    renameTeamFile({ commit, rootGetters }, { teamId, obj_id, to, name, file_key }) {
        let params = Object.assign(
            {
                teamId,
                obj_id,
                to: to + ".eddx",
                name,
                file_key,
            },
            rootGetters.apiParam
        );
        return new Promise((res, rej) => {
            $edApi.reTeamFileName(params).then(() => {
                res();
            });
        });
    },
    removeTeamMember({ commit, rootGetters }, { teamId, userId }) {
        let params = Object.assign(
            {
                teamId,
                user_id: userId,
            },
            rootGetters.apiParam
        );
        return new Promise((res, rej) => {
            $edApi.deleteMember(params).then(() => {
                res();
            });
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
